import { Cell } from '@pelckmans/elementis/components/table';
import ItemFilter from '../ItemFilter';
import { HorizontalScrollContext } from '../../../../context/HorizontalScrollContextProvider';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { TocNodeRowHeader } from '../../hooks/useTableData';

interface Props {
  nodeRowGroups: TocNodeRowHeader[];
}

export function SingleMemberTableHead({ nodeRowGroups }: Props) {
  const { t } = useTranslation();
  const { horizontalScroll } = useContext(HorizontalScrollContext);

  return (
    <thead>
      <tr>
        <Cell.Header
          className="scorable-item-column"
          title={t('PAGES.RESULTS.PER_STUDENT.TABLE.HEADER.TITLE')}
          sticky={horizontalScroll}
        >
          <ItemFilter nodeRowGroups={nodeRowGroups} />
        </Cell.Header>
        <Cell.Header
          title={t('PAGES.RESULTS.PER_STUDENT.TABLE.HEADER.SINGLE_STUDENT.RESULTS')}
          className="result-column"
        />
        <Cell.Header title={t('PAGES.RESULTS.PER_STUDENT.TABLE.HEADER.SINGLE_STUDENT.RELATIVE_SCORE')} />
        <Cell.Header title={t('PAGES.RESULTS.PER_STUDENT.TABLE.HEADER.SINGLE_STUDENT.ABSOLUTE_SCORE')} />
        <Cell.Header title={t('PAGES.RESULTS.PER_STUDENT.TABLE.HEADER.SINGLE_STUDENT.TIME_SPENT')} />
        <Cell.Header title={t('PAGES.RESULTS.PER_STUDENT.TABLE.HEADER.SINGLE_STUDENT.DATE_ACHIEVED')} />
        <Cell.Header className="scorable-item-column__actions" />
      </tr>
    </thead>
  );
}
